import { MDText } from 'i18n-react';

import { isCancelledPage, isCompletedPage } from 'Components/Account/Purchases/Purchases.helpers';
import cypressIds from 'Components/cypress_ids.json';
import type { ColumnCellProps } from 'Storybook/core/Datagrid/Datagrid.types';
import { CellTextAlign } from 'Storybook/core/Datagrid/Datagrid.types';
import type { AccountSlugs, SortBy } from 'Types/account';
import type { Order } from 'Types/generic';

import LocalTexts from './PurchasesVehicleList.texts';

const LocalT = new MDText(LocalTexts);

export const getPurchasesListColumns = ({
	slug,
	sorts,
}: {
	slug: AccountSlugs;
	sorts: { order: Order; sortBy: SortBy };
}): Array<ColumnCellProps> =>
	[
		{
			cypressId: cypressIds.accountDataGrid.dataGridHeaders.vehicles,
			id: 'vehicles',
			sortable: true,
			text: LocalT.translate('headers.vehicle'),
		},
		{
			cypressId: cypressIds.accountDataGrid.dataGridHeaders.status,
			id: 'status',
			text: LocalT.translate('headers.status'),
			textAlign: CellTextAlign.Right,
		},
		{
			cypressId: cypressIds.accountDataGrid.dataGridHeaders.price,
			id: 'price',
			sortable: true,
			text: LocalT.translate('headers.price'),
			textAlign: CellTextAlign.Right,
		},
		...(isCancelledPage(slug)
			? [
					{
						cypressId: cypressIds.accountDataGrid.dataGridHeaders.dateBid,
						id: 'dateBid',
						sortable: true,
						text: LocalT.translate('headers.dateBid'),
						textAlign: CellTextAlign.Right,
					},
			  ]
			: []),
		...(isCompletedPage(slug)
			? [
					{
						cypressId: cypressIds.accountDataGrid.dataGridHeaders.dateWon,
						id: 'dateWon',
						sortable: true,
						text: LocalT.translate('headers.dateWon'),
						textAlign: CellTextAlign.Right,
					},
					{
						id: 'CTA',
						text: LocalT.translate('headers.CTA'),
						textAlign: CellTextAlign.Right,
					},
			  ]
			: []),
	].map((column) => {
		const { id } = column;

		if (id === sorts.sortBy) {
			return { ...column, sortDirection: sorts.order };
		}

		return column;
	});
